import { Platform } from 'react-native';

export default Platform.OS === 'web' &&
  navigator.userAgent &&
  !/(android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini)/i.test(
    navigator.userAgent,
  );
